module.exports = __webpack_public_path__ + "static/media/sfx_amb_fades_01.4b6c2fe3.mp3";